import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconOutboundArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 11 13",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m1.615 3.819.013-.784a.622.622 0 0 1 .608-.609L9.1 2.31a.573.573 0 0 1 .589.588L9.574 9.76a.622.622 0 0 1-.61.609l-.783.013a.576.576 0 0 1-.588-.603l.17-4.153-5.16 5.16a.598.598 0 0 1-.848.014l-.555-.555a.598.598 0 0 1 .014-.848l5.16-5.16-4.157.17a.572.572 0 0 1-.602-.588Z" })
});
export default SvgIconOutboundArrow;
